import { PayloadAction } from "@reduxjs/toolkit";
import { StatusLoading } from 'common/constants/statusLoading';

import { IState } from "../types";

const setPermissionsLoadingStatus = (state: IState, action: PayloadAction<StatusLoading>) => {
  state.permissions.loadingStatus = action.payload;
};

export default setPermissionsLoadingStatus;
